module.exports = __webpack_public_path__ + "img/icon_layer_close.387867c3.svg";